import { render, staticRenderFns } from "./PastLetters.vue?vue&type=template&id=f022417c&"
import script from "./PastLetters.vue?vue&type=script&lang=ts&"
export * from "./PastLetters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports